import List, {ListOptions} from "list.js";

export const createListe = (element: string, options: ListOptions, initialSorted?: IInitialSort) => {
    const historiqueList = new List(element, options);
    if(initialSorted) historiqueList.sort(initialSorted.valueName, initialSorted.options)
    return historiqueList
}

export function initHistoriqueList(){
    createListe('historique-list', {
        valueNames: ['name', 'champ', {attr: 'data-timestamp', name: 'date'}]
    }, {
        valueName: 'date',
        options: { order: "desc" }
    })
}